module.exports = __webpack_public_path__ + "static/img/UTM教室_1.13390ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM教室_1.png
// module id = n8vA
// module chunks = 0